import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/AboutSection";
import WhyChooseMe from "@/components/sections/WhyChooseMe";
import ServicesAndMarketing from "@/components/sections/ServicesAndMarketing";
import FrameworkTimeline from "@/components/sections/FrameworkTimeline";
import CTASection from "@/components/sections/CTASection";

export default function HomePage() {
  return (
    <div data-testid="page-home">
      <Hero />
      <AboutSection />
      <WhyChooseMe />
      <ServicesAndMarketing />
      <FrameworkTimeline />
      <CTASection />
    </div>
  );
}
